<template>
  <section v-if="['MoreSettingsLayout', 'AppLayout', 'ChatLayout'].includes(this.$route.meta.layout)" class="main-panel">
    <AppComponent>
      <component :is="layout">
        <!--            <router-view></router-view>-->
      </component>
    </AppComponent>
  </section>
  <component v-else :is="layout">
    <!--            <router-view></router-view>-->
  </component>
</template>
<script>
import AppComponent from './elements/AppComponent';
import NavBar from './elements/NavBar';

const defaultLayout = 'DefaultLayout';

export default {
  name: 'App',
  components: { AppComponent, NavBar },
  computed: {
    layout() {
      const layout = this.$route.meta.layout || defaultLayout;
      return () => import(`./layouts/${layout}.vue`);
    }
  }
};
</script>
